import { FC } from 'react';

import catSits from 'assets/cat_sits.png';

import { Placeholder } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    description: 'CampaignsDashboard.CampaignsTable.NoCampaignsOnTab.description',
};

export const NoCampaignsOnTab: FC = () => {
    const trls = useTrls();

    return (
        <Placeholder
            data-qa="no-campaigns-on-tab"
            title=""
            description={trls(TrlKeys.description)}
            gapBottom={24}
            gapTop={16}
            paddingTop={48}
        >
            <Placeholder.Image src={catSits} width={110} />
        </Placeholder>
    );
};
